import React, { useEffect, useState } from 'react';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [isVisible, setIsVisible] = useState(false);
  const [isFinePointer, setIsFinePointer] = useState(false);

  useEffect(() => {
    const media = window.matchMedia('(hover: hover) and (pointer: fine)');
    const updatePointerMode = () => setIsFinePointer(media.matches);
    updatePointerMode();
    media.addEventListener('change', updatePointerMode);

    return () => {
      media.removeEventListener('change', updatePointerMode);
    };
  }, []);

  useEffect(() => {
    if (!isFinePointer) {
      setIsVisible(false);
      return undefined;
    }

    const updateCursor = (e) => {
      // If we move the mouse, we must be inside the document
      if (!isVisible) setIsVisible(true);
      
      // Ensure cursor stays within viewport bounds
      const x = Math.max(0, Math.min(e.clientX, window.innerWidth - 16));
      const y = Math.max(0, Math.min(e.clientY, window.innerHeight - 16));
      setPosition({ x, y });
    };

    const handleMouseEnter = () => setIsVisible(true);
    const handleMouseLeave = () => setIsVisible(false);

    document.addEventListener('mousemove', updateCursor);
    document.addEventListener('mouseenter', handleMouseEnter);
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mousemove', updateCursor);
      document.removeEventListener('mouseenter', handleMouseEnter);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [isFinePointer, isVisible]);

  if (!isFinePointer || !isVisible) return null;

  return (
    <div
      className="custom-cursor"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    />
  );
};

export default CustomCursor;
